import React, { useEffect } from 'react'
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import { useParams, useLocation } from 'react-router' 
import ViewInvoiceDetails from '../../containers/invoices/ViewInvoiceDetails';
import InvoicesProvider from '../../store/invoices/invoicesProvider';
import AddInvoice from '../../containers/invoices/AddInvoice';

function InvoiceDetails() {
  const { id } = useParams(); 
  const location = useLocation();

  const { appState: { user }} = useApp();
  const [pageTitle, setPageTitle] = React.useState('');

  const addInvoice = location.pathname.includes('/add');

  useEffect(() => {
    if (id) setPageTitle('Invoice details');
    if (addInvoice) setPageTitle('Add invoice');
  }, [])

  if (!user) return '';
  if (!user._id) return '';

  return (
    <InvoicesProvider>
      <PageWrapper navbar title={pageTitle}>
        {id && <ViewInvoiceDetails invoiceId={id}/>}
        {addInvoice && <AddInvoice />}
      </PageWrapper>
    </InvoicesProvider>
  )
}

export default InvoiceDetails;